export const environment = {
  production: true,
  base_url: "https://analitici.volantinoggi.it",
};
